import { apiRequest } from './client';

export interface SessionUser {
  readonly id: string;
  readonly email: string;
  readonly emailVerified: boolean;
  readonly displayName: string | null;
}

export interface SessionInfo {
  readonly user: SessionUser;
  readonly session: { readonly expiresAt: string };
}

/** The same email-code routes `apps/web` uses. */
export const authApi = {
  session: (signal?: AbortSignal) =>
    apiRequest<SessionInfo>('/auth/session', { signal, allowUnauthenticated: true }),
  /** Always 202, whether or not the address has an account. */
  requestCode: (body: { email: string; locale?: string }) =>
    apiRequest<{ status: 'accepted' }>('/auth/otp/request', {
      method: 'POST',
      body,
      allowUnauthenticated: true,
    }),
  verifyCode: (body: { email: string; code: string }) =>
    apiRequest<SessionInfo>('/auth/otp/verify', {
      method: 'POST',
      body: { ...body, client: 'web' },
      allowUnauthenticated: true,
    }),
  logout: () => apiRequest<void>('/auth/logout', { method: 'POST', allowUnauthenticated: true }),
  /** Platform grants of the signed-in user: the admin guard reads this (same call `apps/web` makes). */
  platformPermissions: (signal?: AbortSignal) =>
    apiRequest<{ permissions: string[] }>('/authorization/me/platform-permissions', { signal }),
};
